import { useQuery } from "react-query";

import useApiHelper from "../../services/useApiHelper";
import { IDefaultResponseWithData } from "../../models/system/DefaultResponse";
import { nurtureCampaignQueryKeys } from "./queryKeys";
import { INurtureCampaignStatistics } from "../../models/nurtureCampaign/NurtureCampaignStatistics";

export function useNurtureCampaignStats(agencyId: string, campaignId: string) {
  const { get } = useApiHelper();

  const stats = useQuery({
    queryKey: nurtureCampaignQueryKeys.statistics(agencyId, campaignId),
    queryFn: () =>
      get(
        `/marketing/${agencyId}/nurture/${campaignId}/statistics`
      ) as unknown as IDefaultResponseWithData<INurtureCampaignStatistics>,
    refetchOnWindowFocus: false,
    enabled: !!campaignId,
  });

  return {
    stats,
  };
}
